import { useState, useEffect } from "react";
import Carousel1 from "../assets/Carousel1.jpg";
import Carousel2 from "../assets/Carousel2.jpg";
import Carousel3 from "../assets/Carousel3.jpg";
import styles from "./HeroCarousel.module.scss";

export const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [Carousel1, Carousel2, Carousel3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className={styles.caruselContainer}>
      <div className={styles.caruselWrapper}>
        <div className={styles.carousel}>
          {slides.map((slide, index) => (
            <div
              key={index}
              className={styles.carouselItem}
              style={{ opacity: index === currentSlide ? 1 : 0 }}
            >
              <img src={slide} alt={`Carousel ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
